<template>
    <div class="servicer">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px">
            <el-form-item label="财税负责人" prop="leader_id">
                <admin-user @choosed="handleChoosed($event,'leader_id')" />
            </el-form-item>
            <el-form-item label="理票会计" prop="acc_id">
                <admin-user @choosed="handleChoosed($event,'acc_id')" />
            </el-form-item>
            <el-form-item label="记账报税会计" prop="advisory_id">
                <admin-user @choosed="handleChoosed($event,'advisory_id')" />
            </el-form-item>
            <el-form-item label="客服会计" prop="ass_id">
                <admin-user @choosed="handleChoosed($event,'ass_id')" />
            </el-form-item>
            <el-form-item label="综合会计" prop="general_accounting">
                <admin-user @choosed="handleChoosed($event,'general_accounting')" />
            </el-form-item>
            <el-form-item label="开票会计" prop="invoice_id">
                <admin-user @choosed="handleChoosed($event,'invoice_id')" />
            </el-form-item>
            <el-form-item label="财税顾问" prop="service_advisor_id">
                <admin-user @choosed="handleChoosed($event,'service_advisor_id')" />
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import AdminUser from '../commonReform/AdminUser'
export default {
    name: 'Servicer',
    components: { AdminUser },
    data() {
        return {
            form: {
                // 财税负责人
                'leader_id': [],
                // 理票会计
                'acc_id': [],
                // 记账报税会计
                'advisory_id': [],
                // 客服会计
                'ass_id': [],
                // 综合会计
                'general_accounting': [],
                // 开票会计
                'invoice_id': [],
                // 财税顾问
                'service_advisor_id': [],
            },
            rules: {}
        }
    },
    methods: {
        handleChoosed(e,type) {
            if (type === 'leader_id') {
                this.form.leader_id = e
            } else if (type === 'acc_id') {
                this.form.acc_id = e
            } else if (type === 'advisory_id') {
                this.form.advisory_id = e
            } else if (type === 'ass_id') {
                this.form.ass_id = e
            } else if (type === 'general_accounting') {
                this.form.general_accounting = e
            } else if (type === 'invoice_id') {
                this.form.invoice_id = e
            } else if (type === 'service_advisor_id') {
                this.form.service_advisor_id = e
            }
            this.$emit('handleChoosed',this.form);
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/AdminComponents/Servicer.vue